import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import axios from 'axios';
import Swal from 'sweetalert2';

export default function UserReturnUrl() {
    const userid = useSelector(state => state.user.uid);

    const [showDiv, setShowDiv] = useState(false);
    const [showData, setShowData] = useState(false);

    useEffect(() => {
        if (userid !== 'none') {
            console.log('userid', userid)
            const mylastetsurl = 'https://garagexy.com/API/stripe/connect_account.php';

            axios.post(mylastetsurl, { action: "CheckEmailConnectedToStripe", id: userid })
                .then((response) => {
                    if (response.data.connected === 1) {
                        setShowDiv('Your account already verified');
                    } else {
                        if (response.data.stripe_id) {
                            axios.post(mylastetsurl, {
                                action: "CheckConnectedAccountByStripe",
                                account_id: response.data.stripe_id
                            })
                                .then((response2) => {
                                    setShowDiv(response2.data.message);
                                    setShowData(response2.data);
                                    if (response2.data.onboarding_url) {
                                        window.location.href=response2.data.onboarding_url;
                                    }

                                })
                        } else {
                            console.log('respons111e.data', response.data)
                            setShowDiv('Stripe Account Id not found:' + response.data);
                        }
                    }
                })
                .catch((error) => {
                    console.error('Error updating payment status:', error);
                });

        }
    }, [userid]);

    return (
        <section className="page-content sec-padding">
            <div className="container-fluid">
                <div className="page-content-details">

                    <div className='sales-items'>
                        <div className='text-center'>
                            <div className="cicle p-2 mb-4">
                                <i className="fa fa-check text-primary" style={{ color: '#ffffff', fontSize: '50px' }}></i>
                            </div><br />
                            <h1 className='text-primary'>{showDiv}</h1>
                            {showData && showData.onboarding_url &&
                                <a
                                    target="_blank" className="btn btn-primary mt-2" href={showData.onboarding_url}>
                                    Complete Stripe Verification</a>

                            }
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
